import { useAuth } from '@clerk/clerk-react';
import { useQueryClient } from '@tanstack/react-query';
import actionTypes from 'actionTypes';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { useIntercom } from 'react-use-intercom';
import { sessionNamespacer } from 'reducers/session';
import { SESSION_ENV_KEY } from 'utils/config';

import { ENTITLEMENTS_QUERY_KEY } from '~constants/entitlements';

interface UseLogoutResult {
	logout: () => Promise<void>;
}

export const useLogout = (): UseLogoutResult => {
	const { isSignedIn, signOut } = useAuth();
	const { shutdown: shutdownIntercomChat } = useIntercom();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const queryClient = useQueryClient();

	const logout = async (): Promise<void> => {
		if (isSignedIn) {
			await signOut();
		}

		shutdownIntercomChat();

		localStorage.removeItem(SESSION_ENV_KEY);
		queryClient.removeQueries({ queryKey: [ENTITLEMENTS_QUERY_KEY] });

		dispatch({
			type: sessionNamespacer(actionTypes.session.REMOVE_SESSION),
			payload: {
				value: false,
			},
		});
		navigate('/login');
	};

	return {
		logout,
	};
};
